import { render, staticRenderFns } from "./DropdownSubMenuItem.vue?vue&type=template&id=0a7c823e&"
import script from "./DropdownSubMenuItem.vue?vue&type=script&lang=js&"
export * from "./DropdownSubMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSubMenuItem.vue?vue&type=style&index=0&id=0a7c823e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports